export const common: Record<string, string> = {
  // Generic actions
  'Language': 'Langue',
  'Cancel': 'Annuler',
  'Confirm': 'Confirmer',
  'Save': 'Enregistrer',
  'Saving...': 'Enregistrement...',
  'Delete': 'Supprimer',
  'Deleting...': 'Suppression...',
  'Edit': 'Modifier',
  'Close': 'Fermer',
  'Back': 'Retour',
  'Next': 'Suivant',
  'Previous': 'Précédent',
  'Search': 'Rechercher',
  'Loading...': 'Chargement...',
  'Retry': 'Réessayer',
  'Refresh': 'Actualiser',
  'Are you sure? This action cannot be undone.':
    'Voulez-vous vraiment continuer ? Cette action est irréversible.',
  'Creating...': 'Création…',
  'Unknown': 'Inconnu',
};
